import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
  blockIndividual,
  getIndividualById,
  unblockIndividual,
  updateRiskRating,
  updateCustomerNumber,
} from '~/api/individual';

const individualByIdKey = (id: string) => ['individual', id];

export const useIndividualById = (id: string | undefined) => {
  return useQuery(individualByIdKey(id!), () => getIndividualById(id!), {
    enabled: !!id,
  });
};

export const useBlockIndividualMutation = (id: string) => {
  const queryClient = useQueryClient();
  return useMutation((note: string) => blockIndividual({ id, note }), {
    onSuccess() {
      queryClient.invalidateQueries(individualByIdKey(id));
    },
  });
};

export const useUnblockIndividualMutation = (id: string) => {
  const queryClient = useQueryClient();
  return useMutation((note: string) => unblockIndividual({ id, note }), {
    onSuccess() {
      queryClient.invalidateQueries(individualByIdKey(id));
    },
  });
};

export const useUpdateIndividualRiskRating = (id: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    (params: { riskRating: string; note: string }) => updateRiskRating({ id, ...params }),
    {
      onSuccess() {
        queryClient.invalidateQueries(individualByIdKey(id));
      },
    }
  );
};

export const useUpdateIndividualCustomerNumber = (id: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    (params: { customerNumber: string; note: string }) => updateCustomerNumber({ id, ...params }),
    {
      onSuccess() {
        queryClient.invalidateQueries(individualByIdKey(id));
      },
    }
  );
};
